export { errorMessage, money, PERIODICIDAD_LABELS, planFeature, PLANS_PATH, PRICE_SUFFIX } from '../../plans/common/plan-common'
export type { PlanFeature } from '../../plans/common/plan-common'

export const SUBSCRIPTION_PATH = '/configuracion/mi-plan'
export const SUBSCRIPTION_BACK_PATH = '/configuracion'
